import {logger} from '../utilities';

const LOG_PREFIX = '[offeringRelations.js]';

export const generateRelations = (list) => {
    let tree = [];
    list.filter((o) => (o.parent_offerings_id === null)).forEach((o) => tree.push({
        id: o.id,
        sort: o.sort,
        type: 'parent',
        children: []
    }));
    list.filter((o) => (o.parent_offerings_id != null)).forEach((o) => {
        const leaf = tree.find(p => p.id === o.parent_offerings_id)
        if (leaf) {
            leaf.children.push({id: o.id, type: 'child', children: []});
        }
    });
    list.filter((o) => (o.parent_offerings_id != null)).forEach((o) => {
        tree.forEach(branch => {
            const leaf = branch.children.find(p => p.id === o.parent_offerings_id)
            if (leaf) {
                leaf.children.push({id: o.id, type: 'grandchild', children: []});
            }
        });
    });
    tree.forEach(c => {
        c.children.forEach(g => {
            g.children.sort((a, b) => ((a.sort > b.sort) ? 1 : -1));
        });
        c.children.sort((a, b) => ((a.sort > b.sort) ? 1 : -1));
    })
    tree.sort((a, b) => ((a.sort > b.sort) ? 1 : -1));

    logger.debug(LOG_PREFIX, '.generateRelations()', {message: `relations build... ${tree}.`});
    return tree;
}